export default __webpack_public_path__ + "static/media/success.8fa56595.png";